/**
 * Created by Ning Jiang on 8/1/2016.
 * Refactored by Ning Jiang on 1/23/2017.
 */

import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { ParticleController } from "./ParticleController";
import { BigWinParticleController } from "./BigWinParticleController";
import { ParticleSettings } from "./ParticleSettings";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SanGameConfig } from "../../../SanGameConfig";
import { ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";


export class ParticlesManager extends BaseView {

    private static _normalParticleC:ParticleController; 
    private static _bigWinParticle:BigWinParticleController[] = []; 

    private static _configs:ParticleSettings;

    public static get normalParticles():ParticleController{ 
        return this._normalParticleC;
    }

    public static bigWinParticles(lvl:number):BigWinParticleController{ 
        return this._bigWinParticle[lvl];
    }

    public static playMinicwin():void{
        this._bigWinParticle[0].enableEmit(true);
    }

    public static playManiacwin():void{
        this._bigWinParticle[this._bigWinParticle.length-1].enableEmit(true);
    }

    public static playBigwin(lvl:number):void{

        this._bigWinParticle.forEach((bw,i) => { 
            bw.enableEmit(i == lvl);
        })

        for (let index = 1; index <= 5; index++) {
            SoundManager.stopSoundEffect(SoundConfig.instance.BIG_WIN_LVL + (index))
        }

        if(lvl == 4) this.playManiacwin();

        SoundManager.playSoundEffect(SoundConfig.instance.BIG_WIN_LVL + (lvl + 1), Number.MAX_SAFE_INTEGER);
    }

    public static stopBigWin():void{ 
        this._bigWinParticle.forEach(bw => bw.enableEmit(false) )
    }

    constructor() {
        super();
        ParticlesManager._configs = new ParticleSettings();
        StageManager.getLayer(SanGameConfig.instance.LAYERS.FX_WIN.name).addChild(this);
    }

    protected initAnimations():void {
        for(let i:number = 2; i < ParticlesManager._configs.allConfigs.length; i++){
            ParticlesManager._bigWinParticle.push(new BigWinParticleController("BigWin"+i, this, ParticlesManager._configs.allConfigs[i],i == ParticlesManager._configs.allConfigs.length-1));
        }
        
        ParticlesManager._normalParticleC = new ParticleController("Particles/Cig", this);
        ParticlesManager._normalParticleC.setPos(new PIXI.Point(370,310));
    }

    onResize():void{
        ParticlesManager._bigWinParticle.forEach(b => b.setPos(new PIXI.Point(370, ResizeHelper.IsLandscape() ?  280 : 0)));
    }
}